
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'SummaryErrors',
  computed: {
    getBet(): any {
      return this.$store.getters['cart/getBet'];
    },
    getSettings(): any {
      return this.$store.getters['cart/getSettings'];
    },
    showOddsUpdateMessage(): boolean {
      return this.$store.getters['sport/showOddsUpdateMessage'];
    },
    displayedErrorsMultiInfo(): Array<{ message: string }> {
      if (
        this.getBet.errors_multi_info &&
        this.getBet.errors_multi_info.length > 0
      ) {
        return this.getBet.errors_multi_info;
      }

      if (this.getBet.type === 'system') {
        return [];
      }

      let multiplicity = 0;
      if (this.getBet.type === 'single' || this.getBet.type === 'multiple') {
        multiplicity = +this.getBet._multiple_detail.multiplicity;
      } else if (this.getBet.type === 'integral') {
        multiplicity = +this.getBet._integral_detail.multiplicity;
      }
      let multiMinimum = 0;
      for (const odd of this.getBet.odds || []) {
        if (odd && +odd.multiplicity_min > multiMinimum)
          multiMinimum = +odd.multiplicity_min;
      }
      if (multiplicity < multiMinimum && multiMinimum > 0) {
        return [{ message: `multiplicity_info_${multiMinimum}` }];
      }
      return [];
    },
    displayedErrors(): Array<{ message: string; value?: number }> {
      if (this.getBet.errors && this.getBet.errors.length > 0) {
        return this.getBet.errors;
      }
      const errors: Array<{ message: string; value?: number }> = [];
      const ctx = this.getBet.context;
      const settings = this.getSettings || {};
      let amount = 0;
      if (this.getBet.type === 'single' || this.getBet.type === 'multiple') {
        amount = +this.getBet._multiple_detail.amount;
      } else if (this.getBet.type === 'integral') {
        amount = +this.getBet._integral_detail.amount;
      } else if (this.getBet.type === 'system') {
        amount = +this.getBet._system_detail.amount_system;
      }
      if (ctx === 'prematch') {
        const minAmount = settings.minAmount;
        const prematchMax = settings.prematch_max_amount;
        if (minAmount != null && +minAmount > 0 && amount < +minAmount) {
          errors.push({
            message: 'minimumAmountNotRespected',
            value: +minAmount
          });
        }
        if (prematchMax != null && +prematchMax > 0 && amount > +prematchMax) {
          errors.push({
            message: 'maximumAmountNotRespected',
            value: +prematchMax
          });
        }
      } else if (ctx === 'live' || ctx === 'mixed') {
        const liveMin = settings.live_min_amount;
        const liveMax = settings.live_max_amount;
        if (liveMin != null && +liveMin > 0 && amount < +liveMin) {
          errors.push({
            message: 'minimumAmountNotRespected',
            value: +liveMin
          });
        }
        if (liveMax != null && +liveMax > 0 && amount > +liveMax) {
          errors.push({
            message: 'maximumAmountNotRespected',
            value: +liveMax
          });
        }
      }
      return errors;
    },
    displayedWarnings(): Array<{ message: string; value?: number }> {
      return this.getBet.warnings || [];
    }
  },
  methods: {
    t(key: string): string {
      return this.$t(key) as string;
    },
    getErrorDesc(message: string): string {
      const split = message.split('#');
      return split[0] + ' ' + this.t(split[1]);
    }
  }
});
